export default class Accomodations {
  constructor () {

  }
}
